import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MembershipStatusStripView } from '../../utils/membership-status-strip.util';

/**
 * CWS-1650: membership status strip at the top of the New Order Request history card.
 * Red for a refused member, purple for an active membership that used its washes, and
 * lavender with an info icon for an active member's status line (CWS-1730).
 * `section="suggestion"` renders the suggestion row, which sits under the history row.
 */
@Component({
  selector: 'app-membership-status-strip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './membership-status-strip.component.html',
  styleUrls: ['./membership-status-strip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MembershipStatusStripComponent {
  @Input({ required: true }) strip!: MembershipStatusStripView;
  @Input() section: 'head' | 'suggestion' = 'head';
}
